import { FlyoutButton, Icon, Spinner } from '@acpaas-ui/react-components';
import { useState } from 'react';
import { toReadableTemplateFileKey } from '../../lib/template.utils';
import templatesService from '../../services/api/templates.service';

const DossierTemplates = ({ category }) => {
  const [areLoaded, setAreLoaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [loadError, setLoadError] = useState('');
  const [templates, setTemplates] = useState([]);

  const handleOpen = () => {
    if (category && !isLoading && !areLoaded) {
      setIsLoading(true);
      templatesService.getForCategory(category, {
        onError: (message) => {
          setLoadError(message);
          setIsLoading(false);
        },
        onSuccess: (response) => {
          setTemplates(response);
          setIsLoading(false);
          setAreLoaded(true);
        }
      });
    }
  };

  return (
    <div onClick={handleOpen}>
      <FlyoutButton
        iconRight="ai-arrow-down-1"
        outline
        size="tiny"
        flyoutDirection="right"
        label="Sjablonen"
        ariaLabel="Openen sjablonen"
      >
        <div onClick={(e) => e.stopPropagation()}>
          <ul className="m-selectable-list m-selectable-list--no-border">
            {loadError ? (
              <li className="m-selectable-list__item u-no-pointer-events u-flex">
                <Icon name="ai-alert-triangle" className="u-margin-right-xs u-text-danger" />
                <span className="u-text-danger">{loadError}</span>
              </li>
            ) : (
              isLoading && (
                <li key={'loading'} className="m-selectable-list__item u-no-pointer-events u-text-center">
                  <Spinner />
                </li>
              )
            )}
            {templates?.map((t) => (
              <li key={t.id} className="m-selectable-list__item u-padding-none">
                <a className="u-block u-padding" href={t.fileUrl} rel="noreferrer" target="_blank">
                  <Icon name="ai-download-bottom" className="u-margin-right-xs" />
                  {toReadableTemplateFileKey(t.fileKey)}
                </a>
              </li>
            ))}
            {areLoaded && templates?.length === 0 && (
              <li className="m-selectable-list__item u-no-pointer-events">
                <span className="u-text-light">Er zijn nog geen sjablonen voor deze categorie.</span>
              </li>
            )}
          </ul>
        </div>
      </FlyoutButton>
    </div>
  );
};

export default DossierTemplates;
